<template>
  <!-- <section id="main-container" class="main-container" :class="collapse ? 'position-collapse-left' : 'position-left'"> -->
  <section
    id="main-container"
    class="main-container"
    :class="collapse ? 'position-collapse-left' : 'position-left'"
  >
    <head-bar></head-bar>
    <main class="container">
      <transition name="fadeInFn" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>

    <div class="beian-bottom">
      <div class="beian-container">
        <div class="beian-container-li">
          <a href="/" class="inc-box_logo"
            ><img src="@/assets/logo_gold.png"
          /></a>
        </div>
        <!-- <div class="beian-container-li">
          <a href="/#/">Home</a>
          <el-divider direction="vertical"></el-divider>
          <a href="/#/course">Courses</a>
          <el-divider direction="vertical"></el-divider>
          <a href="/#/schoolclubs">School Clubs</a>
        </div> -->
        <div class="beian-container-li beian-container-site">
          <div class="beian-container-site-li1">
            <a href="/#/">Home</a>
            <el-divider direction="vertical"></el-divider>
            <a href="/#/about">About</a>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="beian-container-site-li2">
            <a href="/#/career">Careers</a>
            <el-divider direction="vertical"></el-divider>
            <a href="/#/privacy">Privacy</a>
          </div>
        </div>
      </div>
      <div class="inc-box">
        <div class="inc-container_li">COPYRIGHT @ {{ nowYear }} COVEY INC.</div>
        <div class="inc-container_li">ALL RIGHTS RESERVED.</div>

        <div class="social-item_box">
          <div class="social-item_li">
            <a href="https://twitter.com" target="_blank"
              ><img class="social-item" src="@/assets/icon/twitter.svg"
            /></a>
          </div>
          <div class="social-item_li">
            <a href="https://facebook.com" target="_blank"
              ><img class="social-item" src="@/assets/icon/facebook.svg"
            /></a>
          </div>
          <div class="social-item_li">
            <a href="https://linkedin.com" target="_blank"
              ><img class="social-item" src="@/assets/icon/linkedin.svg"
            /></a>
          </div>
          <div class="social-item_li">
            <a href="https://instagram.com" target="_blank"
              ><img class="social-item" src="@/assets/icon/instagram.svg"
            /></a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="popup" v-if="overalLoaded">
            <div class="msg">
                <i class="el-icon-loading"></i>
                <div>执行中,请勿关闭页面</div>
            </div>
        </div> -->
  </section>
</template>

<script>
import { mapState } from "vuex";
import HeadBar from "../HeadBar/HeadBar.vue";
import moment from "moment";
export default {
  components: {
    HeadBar,
  },
  data() {
    return {
      nowYear: moment().format("YYYY"),
    };
  },
  computed: {
    ...mapState({
      overalLoaded: (state) => state.app.overalLoaded,
      collapse: (state) => state.app.collapse,
      userInfo: (state) => state.app.userInfo,
    }),
  },
  watch: {
    userInfo: {
      handler: function (newVal, oldVal) {
        if (newVal.status === -2) {
          document.querySelector("#main-container").style["padding-top"] =
            "140px";
        } else {
          document.querySelector("#main-container").style["padding-top"] =
            "60px";
        }
      },
      // immediate: true,
    },
  },
  mounted() {
    // console.log("this.route", this.userInfo.status, this.$route);
    // if (this.userInfo.status === -2) {
    //   document.querySelector("#main-container").style["padding-top"] = "140px";
    // } else {
    //   document.querySelector("#main-container").style["padding-top"] = "60px";
    // }
  },
  methods: {},
};
</script>

<style lang="scss">
@import "~@/utils/vw.scss";
.max-width-box {
  max-width: 90%;
  margin: 0 auto;
}
.main-container {
  width: 100%;
  // min-width: 1200px;
  padding-top: 80px;
  background-color: #f9f9f9;
  transition: left 0.3s;
  box-sizing: border-box;
  // overflow: hidden;
  .beian-bottom {
    // position: relative;
    width: 100%;
    padding: 32px 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    // height: vw(200);
    .beian-container {
      a {
        display: inline-block;
        color: #000;
        text-decoration: none;
      }
      .beian-container-li {
        height: 35px;
        line-height: 35px;
        text-align: center;
        // display: grid;
        // grid-template-columns: repeat(3, 1fr);
        margin-bottom: 10px;
        .inc-box_logo {
          display: inline-block;
          height: 30px;
          img {
            width: 75px;
            height: 30px;
          }
        }
      }
      .beian-container-site {
        display: flex;
        align-items: center;
        justify-content: center;
        .beian-container-site-li1 {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .beian-container-site-li2 {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        a {
          display: inline-block;
          padding: 0 5px;
        }
      }
    }
    .inc-box {
      margin-top: 12px;
      text-align: center;
      .inc-container_li {
        height: 35px;
        line-height: 35px;
      }
      //   height: 76px;
    }
    .social-item_box {
      height: 20px;
      display: flex;
      justify-content: center;
      margin: 10px 0;
      .social-item_li {
        // margin-left: 24px;
        width: 48px;
        a {
          //   display: flex;
          text-decoration: none;
          cursor: pointer;
          height: 24px;
          transition: 0.3s;
          border-radius: 50%;
          //   &:hover {
          //     // padding: 8px;
          //     // margin: -8px;
          //     // padding: 8px;
          //     background: #e6e6e6;
          //   }
        }
        .social-item {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    color: #409eff;
    text-align: center;
    .msg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    i {
      font-size: 22px;
      margin-bottom: 4px;
    }
  }
  .container {
    // padding: 18px;
    // max-width: 1580px;
    // width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    box-sizing: border-box;
    .el-loading-mask {
      z-index: 99;
    }
    .xhm-layout {
      padding: 12px;
      background-color: #fff;
      border-radius: 4px;
      margin-bottom: 10px;
    }
    .xhm-sign {
      position: relative;
      padding-left: 12px;
      i {
        position: absolute;
        top: 7px;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #e6a23c;
      }
    }
    .xhm-layout-title {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 40px;
      background-color: #fff;
      padding: 0 10px;
      border-bottom: 1px solid #f2f2f2;
      i {
        color: #56a0f4;
        font-size: 16px;
        margin-right: 12px;
      }
    }
    .xhm-layout-title__img {
      width: 14px;
      display: block;
      margin-right: 12px;
    }
    .xhm-search {
      display: flex;
      padding-top: 16px;
      .el-form-item {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 14px;
        zoom: 1;
        .el-form-item__label {
          float: left;
          font-size: 13px;
          color: #666;
          padding: 0;
        }
        .el-form-item__content {
          margin-left: 110px;
          display: block;
          box-sizing: border-box;
          .el-select {
            width: 100%;
          }
          .el-date-editor {
            width: 100%;
          }
        }
      }
      .xhm-search-icon__status {
        position: absolute;
        top: 6px;
        right: -24px;
        font-size: 16px;
        color: #666;
      }
    }
    .xhm-search-form {
      flex: 1 1;
    }
    .xhm-search-btn {
      width: 100px;
      margin: 0 40px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .el-button + .el-button,
      .xhm-button + .xhm-button {
        margin-left: 0;
        margin-top: 12px;
      }
    }
    .xhm-search-away {
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: #666;
    }
    .xhm-search-away__btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        padding: 0 6px;
      }
      &:hover {
        color: #0076ff;
      }
    }
    .xhm-demo-refresh {
      padding: 4px 10px;
      cursor: pointer;
      font-size: 20px;
      &:hover {
        color: #0076ff;
      }
    }
    .xhm-center {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: center;
    }
    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background: #e4e4e4;
      color: #909399;
      font-size: 26px;
    }
    .flexDirection {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .search_fn {
      .el-form-item {
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 14px;
        zoom: 1;
        .el-form-item__label {
          float: left;
          font-size: 12px;
        }
        .el-form-item__content {
          margin-left: 110px;
          display: block;
          box-sizing: border-box;
          .el-select {
            width: 100%;
          }
          .el-date-editor {
            width: 100%;
          }
        }
      }
    }
    .ellipsis3 {
      letter-spacing: 0;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3; /*要显示的行数*/
      -webkit-box-orient: vertical;
    }
    .ellipsis2 {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2; /*要显示的行数*/
      white-space: nowrap;
    }
    .ellipsis1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-table {
      .cell {
        p {
          margin: 0;
        }
      }
    }
    .el-progress-bar__outer {
      background-color: #bbb;
    }

    .el-dialog__header {
      padding: 16px;
      box-sizing: border-box;
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      color: #201002;
      .el-dialog__title {
        font-size: 24px;
      }
    }
    .el-dialog__body {
      padding: 0 16px 16px;
      box-sizing: border-box;
    }
    .el-dialog__footer {
      padding: 15px 24px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      .el-button {
        min-width: 65px;
      }
    }
    .commodity_card {
      margin-bottom: 12px;
      .card_box {
        position: relative;
        height: 0;
        padding-top: 100%;
        box-sizing: border-box;
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
        .card_msg {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 8px;
          background-color: rgba(0, 0, 0, 0.4);
          font-size: 12px;
          color: #fff;
          box-sizing: border-box;
        }
      }
      .card_foot {
        display: flex;
        align-items: center;
        margin: 8px 10px;
        font-size: 12px;
        justify-content: space-between;
      }
    }
    .form-info-item {
      display: flex;
      margin-bottom: 12px;
      align-items: center;
      font-size: 14px;
      label {
        // width: 110px;
        // text-align: right;
        color: #333;
        // margin-right: 8px;
      }
    }
    .el-form-item {
      margin-bottom: 20px;
      .el-input {
        .el-input-group__append {
          padding: 0 10px;
        }
      }
    }
  }
  .main-content {
    background-color: #f6f6fa;
  }
}
.position-left {
  margin-left: 200px;
}
.el-date-table td span {
  border-radius: 0;
}
.el-date-table {
  //全局日期选择样式
  td.end-date div {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  td.start-date div {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}

.position-collapse-left {
  left: 0px;
}
.title {
  position: relative;
  top: -18px;
  left: -18px;
  width: calc(100% + 36px);
  min-height: 100px;
  background: #ffffff;
  padding: 16px 32px 0 32px;
  box-sizing: border-box;

  .par_page {
    color: #86888b;
    font-size: 12px;
    cursor: pointer;
  }
  .current_page {
    color: #555658;
    font-size: 12px;
    cursor: pointer;
  }
  .leftmargin {
    margin-right: 32px;
  }
  .el-tabs--border-card {
    box-shadow: none;
    border: none;
    .el-tabs__header {
      // padding: 15px 0;
      // padding-top: 15px;
      height: 60px;
      background: #ffffff;
      width: 100%;
      border: none;
      .el-tabs__item {
        border: none;
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        font-weight: 500;
        padding: 0 !important;
        margin-right: 32px;
        line-height: 60px;
        height: 60px;
      }
      .el-tabs__item.is-active {
        color: #1890ff;
      }
    }
    .el-tabs__content {
      width: 100%;
      padding: 0;
      margin-top: -18px;
      .el-menu {
        border-bottom: none;
      }
      .el-menu-item {
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
        padding: 0 !important;
        margin-right: 40px;
      }
      .el-menu-item.is-active {
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
      }
    }
    .el-date-editor .el-range-separator {
      padding: 0 5px;
      line-height: 32px !important;
      height: 32px !important;
      width: 5%;
      color: #303133;
    }
    .el-picker-panel__body-wrapper {
      .el-picker-panel__body {
        .el-picker-panel__content {
          .el-date-table td.start-date div {
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
          }
          .el-date-table td span {
            border-radius: 0 !important;
          }
          .in-range {
            background-color: #e6f7ff !important;
          }
        }
      }
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #000000;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #1890ff;
    color: #1890ff;
  }
  .el-menu-demo {
    .el-menu-item {
      font-size: 20px;
      font-weight: 500;
      padding: 0;
    }
  }
}

.el-table__fixed {
  height: calc(100% - 5px) !important;
}
//滚动条置顶
.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}
// 滚动条的宽度
.el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}
// 滚动条的滑块
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}
.el-button--primary {
  color: #fff;
  background-color: #3271ff;
  border-color: #409eff;
}
.search_top {
  //页面基本搜索区域
  padding: 6px 6px 24px 6px;
  box-sizing: border-box;
  .search_box {
    width: 100%;
    height: 64px;
    font-size: 14px;
    background: #ffffff;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .el-input__inner {
      background: #f2f2f2;
      border: none;
    }
    .el-range-input {
      background: #f2f2f2;
      border: none;
    }
  }
}

.account_box {
  //页面基本内容区域
  background: #ffffff;
  padding: 0 24px 10px 24px;
  .account_title {
    color: #000000;
    font-weight: 500;
    padding: 20px 0;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.circleError {
  padding: 4px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.circleSuccess {
  padding: 4px;
  background-color: #52c41a;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.circleWarning {
  padding: 4px;
  background: #faad14;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}
.circleDelete {
  padding: 4px;
  background: #b5b5b5;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}

.sucaiurl {
  color: #2392fc;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}
.sucaiurl:hover {
  text-decoration: underline;
}
// @media screen and (max-width: 1366px) {
//   .position-left {
//     margin-left: 200px;
//   }
// }
// @media screen and (max-width: 992px) {
//   .main-container {
//     .tab_head {
//       padding: 5px 10px;
//     }
//     .main-content {
//       left: 0;
//       #container {
//         min-width: 300px;
//       }
//     }
//   }
//   .position-left,
//   .position-collapse-left {
//     margin-left: 0px;
//   }
// }
</style>
